import React from 'react';

import IconButton from 'components/common/IconButton';

import UploadEMET from 'components/uploads/UploadEMET';

const TableActions = ({ handleExport }) => {
     
    return (
        <div id="orders-actions">
            <IconButton
                variant="falcon-default"
                size="sm"
                icon="download"
                transform="shrink-3"
                className="me-2"
                iconAlign="middle"
                onClick={handleExport} >
                <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
                    Descargar
                </span>
            </IconButton>
            {/*<Dropdown align="end" className="btn-reveal-trigger d-inline-block">
                <Dropdown.Toggle split variant="falcon-default" size="sm">
                    <FontAwesomeIcon icon="ellipsis-h" className="fs--2" />
                </Dropdown.Toggle>
                <Dropdown.Menu className="border py-0">
                    <div className="py-2">
                        <Dropdown.Item>View</Dropdown.Item>
                        <Dropdown.Item>Export</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item className="text-danger">Remove</Dropdown.Item>
                    </div>
                </Dropdown.Menu>
            </Dropdown>*/}
        </div>
    );
}

export default TableActions;